module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "doc-component",
    attrs: {
      "id": "icon"
    }
  }, [_c('h1', [_vm._v("Ícones")]), _vm._v(" "), _c('ul', {
    staticClass: "icons"
  }, [_c('li', {
    staticClass: "icon-check"
  }, [_vm._v("icon-check")]), _vm._v(" "), _c('li', {
    staticClass: "icon-moip-logo"
  }, [_vm._v("icon-moip-logo")]), _vm._v(" "), _c('li', {
    staticClass: "icon-moip-logo-old"
  }, [_vm._v("icon-moip-logo-old")]), _vm._v(" "), _c('li', {
    staticClass: "icon-enter-right"
  }, [_vm._v("icon-enter-right")]), _vm._v(" "), _c('li', {
    staticClass: "icon-enter-left"
  }, [_vm._v("icon-enter-left")]), _vm._v(" "), _c('li', {
    staticClass: "icon-copy"
  }, [_vm._v("icon-copy")]), _vm._v(" "), _c('li', {
    staticClass: "icon-label-warning"
  }, [_vm._v("icon-label-warning")]), _vm._v(" "), _c('li', {
    staticClass: "icon-label-empty"
  }, [_vm._v("icon-label-empty")]), _vm._v(" "), _c('li', {
    staticClass: "icon-label-error"
  }, [_vm._v("icon-label-error")]), _vm._v(" "), _c('li', {
    staticClass: "icon-label-success"
  }, [_vm._v("icon-label-success")]), _vm._v(" "), _c('li', {
    staticClass: "icon-link"
  }, [_vm._v("icon-link")]), _vm._v(" "), _c('li', {
    staticClass: "icon-moip-symbol"
  }, [_vm._v("icon-moip-symbol")]), _vm._v(" "), _c('li', {
    staticClass: "icon-arrow-down"
  }, [_vm._v("icon-arrow-down")]), _vm._v(" "), _c('li', {
    staticClass: "icon-arrow-up"
  }, [_vm._v("icon-arrow-up")]), _vm._v(" "), _c('li', {
    staticClass: "icon-arrow-left"
  }, [_vm._v("icon-arrow-left")]), _vm._v(" "), _c('li', {
    staticClass: "icon-arrow-right"
  }, [_vm._v("icon-arrow-right")]), _vm._v(" "), _c('li', {
    staticClass: "icon-circle-arrow-down"
  }, [_vm._v("icon-circle-arrow-down")]), _vm._v(" "), _c('li', {
    staticClass: "icon-eye"
  }, [_vm._v("icon-eye")]), _vm._v(" "), _c('li', {
    staticClass: "icon-eye-inverse"
  }, [_vm._v("icon-eye-inverse")]), _vm._v(" "), _c('li', {
    staticClass: "icon-radio-empty"
  }, [_vm._v("icon-radio-empty")]), _vm._v(" "), _c('li', {
    staticClass: "icon-radio-selected"
  }, [_vm._v("icon-radio-selected")]), _vm._v(" "), _c('li', {
    staticClass: "icon-search"
  }, [_vm._v("icon-search")]), _vm._v(" "), _c('li', {
    staticClass: "icon-spinner"
  }, [_vm._v("icon-spinner")]), _vm._v(" "), _c('li', {
    staticClass: "icon-edit"
  }, [_vm._v("icon-edit")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76666906!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Icons.vue
// module id = 145
// module chunks = 1